
import { createAction, props } from '@ngrx/store';
import { UploadActionProps } from '../../guards/resolver.helper';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';
import { CreateUglImportTaskRequest, DeleteUglImportTaskRequest, EditUglImportTaskRequest } from '@dave/types';
import { UglImportTaskEntity } from '../../entities/ugl-import-task.entity';
import { DaveMutationCreateBusinessVolumeArgs } from '../../graphql-types';


const prefix = 'data/' + 'uglImportTask/';
export const UglImportTaskActionTypes = {
    Load: createAction(prefix + 'load', props< UploadActionProps >()),
    Change: createAction(prefix + 'change', props<{ Payload: EditUglImportTaskRequest }>()),
    Delete: createAction(prefix + 'delete', props<{ Payload: DeleteUglImportTaskRequest }>()),


    UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<UglImportTaskEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateMany: createAction(prefix + 'updateMany', props<{ Payload: Array<UglImportTaskEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateOne: createAction(prefix + 'updateOne', props<{ Payload: UglImportTaskEntity }>()),
    RemoveOne: createAction(prefix + 'remove', props<{ Payload: number }>()),

    CreateRequest: createAction(prefix + 'create/request', props<{ Payload: CreateUglImportTaskRequest }>()),
    CreateSuccess: createAction(prefix + 'create/success', props<{ Payload: UglImportTaskEntity }>()),
    CreateFailure: createAction(prefix + 'create/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
};
